import axios from "axios";
import localforage from "localforage";
import { store } from "./Store/configureStore";
import { logout } from "./Store/Actions";
import URL from "./urls";
import Bugsnag from "@bugsnag/js";
// import { trackResponseAnomaly } from "./axiosAnomalyTracker";

const tokenKey = "@Token:";
// Variable store the token values for faster access
let tokenHeaders;
// Only these response headers are auth tokens. Anything else (e.g. "date",
// "content-length") is forbidden for browsers to set on a request.
const AUTH_HEADER_KEYS = ["access-token", "client", "uid", "expiry"];
const pickAuthHeaders = headers =>
  AUTH_HEADER_KEYS.reduce((acc, key) => {
    if (headers?.[key] !== undefined) acc[key] = headers[key];
    return acc;
  }, {});
// Default Headers which needs to be sent in all requests.
const defaultHeaders = {
  common: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-ih-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
};
// Axios Default configurations
const defaultConfig = {
  timeout: 30000,
  // transformRequest: [transformAxiosRequest],
  headers: { ...defaultHeaders.common },
};

export const getTokenHeaders = async () => {
  try {
    if (tokenHeaders && tokenHeaders["access-token"]) {
      return tokenHeaders;
    }

    const tokenFromLocalStorage = await localforage.getItem(tokenKey);
    return JSON.parse(tokenFromLocalStorage);
  } catch (err) {
    Bugsnag.notify(err);
    return null;
  }
};

export const getTokenHeadersBase64 = async () => {
  let tokenStr;
  if (tokenHeaders && tokenHeaders["access-token"]) {
    tokenStr = JSON.stringify(tokenHeaders);
  } else {
    tokenStr = await localforage.getItem(tokenKey);
  }

  if (tokenStr) {
    return Buffer.from(tokenStr).toString("base64");
  }

  return null;
};

export const getUserAuthTokenFromSecureStore = () => {
  return new Promise((resolve, reject) => {
    localforage
      .getItem(tokenKey)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
};

export const storeAuthTokensToSecureStore = tokenHash => {
  tokenHeaders = tokenHash ? pickAuthHeaders(tokenHash) : tokenHash;
  return new Promise((resolve, reject) => {
    if (tokenHash) {
      let stringifiedTokens = JSON.stringify(tokenHeaders);
      localforage
        .setItem(tokenKey, stringifiedTokens)
        .then(res => resolve(res))
        .catch(err => reject(err));
    }
  });
};

const removeAuthTokensFromSecureStore = () => {
  return new Promise((resolve, reject) => {
    localforage
      .removeItem(tokenKey)
      .then(r => {
        // removeItem('user')
        // .then((res => {
        //   resolve(res)
        // }), (err) => console.log(err))
        resolve(r);
      })
      .catch(err => reject(err));
  });
};

// Sets the authentication headers on each request.
// value would be taken if present in the local variable else will take from AsyncStorage
const setTokenHeadersOnRequest = async config => {
  let requestConfig = { ...config };
  let requestHeader = { ...config.headers };
  let authHeader = {};

  if (tokenHeaders) {
    authHeader = pickAuthHeaders(tokenHeaders);
  } else {
    let storeAuthTokensString = await getUserAuthTokenFromSecureStore().catch(
      err => {}
    );
    if (storeAuthTokensString) {
      let storeAuthTokens = JSON.parse(storeAuthTokensString);
      if (storeAuthTokens && storeAuthTokens["access-token"]) {
        authHeader = pickAuthHeaders(storeAuthTokens);
      }
    }
  }
  if (authHeader) {
    requestHeader = { ...requestHeader, ...authHeader };
    requestConfig.headers = { ...requestHeader };
  }
  return requestConfig;
};

const requestInterceptorError = error => {
  return Promise.reject(error);
};

// Store the authentication headers in local variable and AsyncStorage for in case the applicattion closes
// const storeTokenHeadersOfResponse = async response => {
//   let responseHeader = { ...response.headers };
//   if (responseHeader && responseHeader["access-token"]) {
//     let { expiry, uid, client } = responseHeader;
//     let accessToken = responseHeader["access-token"];
//     if (expiry && uid && client && accessToken) {
//       tokenHeaders = { expiry, uid, client };
//       tokenHeaders["access-token"] = accessToken;
//       await storeAuthTokensToSecureStore(tokenHeaders).catch(err => {});
//     } else {
//     }
//   }
//   return response;
// };

const responseInterceptorCallback = response => {
  // trackResponseAnomaly(response);
  return response;
};

const responseInterceptorError = error => {
  return new Promise((resolve, reject) => {
    if (error?.response?.status === 401) {
      const { url } = error?.response?.config || {};
      if (url !== URL.login && url !== URL.decodeSecureToken) {
        store?.dispatch?.(logout());
      }
    } else if (error?.response?.status === 300) {
    }
    reject(error);
  });
};

const axiosInstance = axios.create({ ...defaultConfig });

axiosInstance.interceptors.request.use(
  setTokenHeadersOnRequest,
  requestInterceptorError
);
axiosInstance.interceptors.response.use(
  responseInterceptorCallback,
  responseInterceptorError
);

export default axiosInstance;
